/*
 @author: M.Wang
 Created by preference on 2023/01/09
*/
const imgRe = /.*\.(jpe?g|png)$/i
export default {
  bind: function (el) {
    const srcHandler = (src, attribute = 'bg-url') => {
      if (!src) return
      if (src.includes('data:image/')) {
        const bgImage = el.style.backgroundImage
        if (bgImage && bgImage !== 'none') {
          el.style.backgroundImage = `${bgImage}, url(${src})`
        } else {
          el.style.backgroundImage = `url(${src})`
        }
        el.removeAttribute(attribute)
        return
      }

      // 代码无用
      if (
        process.env.NODE_ENV === 'production' &&
        imgRe.test(src) &&
        window._webp_
      ) {
        src = src.replace(/(?:\.\w+)(\?|$)/, '.webp$1')
        el.setAttribute(attribute, src)
      }

      if (window.__preload__ && window.__preload__[src]) {
        const bgImage = el.style.backgroundImage
        if (bgImage && bgImage !== 'none') {
          el.style.backgroundImage = `${bgImage}, url(${src})`
        } else {
          el.style.backgroundImage = `url(${src})`
        }
        el.removeAttribute(attribute)
      }
    }
    // 多层背景
    let src = el.getAttribute('bg-url')
    let src1 = el.getAttribute('bg-url1')
    let src2 = el.getAttribute('bg-url2')
    srcHandler(src)
    srcHandler(src1, 'bg-url1')
    srcHandler(src2, 'bg-url2')
  },
}
